import { Navigate, createBrowserRouter, type RouteObject } from 'react-router';
import { AuditLogPage } from './features/audit/AuditLogPage';
import { AuditEntryPage } from './features/audit/AuditEntryPage';
import { AppLayout } from './layout/AppLayout';
import { HomePage } from './features/home/HomePage';
import { NotFoundPage } from './features/common/NotFoundPage';
import { AccessibilityStatementPage } from './features/common/AccessibilityStatementPage';
import { LogoutPage } from './features/common/LogoutPage';
import { SubjectsListPage } from './features/subjects/SubjectsListPage';
import { SubjectDetailPage } from './features/subjects/SubjectDetailPage';
import { SubjectFormPage } from './features/subjects/SubjectFormPage';
import { InspectorsListPage } from './features/inspectors/InspectorsListPage';
import { InspectorDetailPage } from './features/inspectors/InspectorDetailPage';
import { InspectorFormPage } from './features/inspectors/InspectorFormPage';
import { InspectionsListPage } from './features/inspections/InspectionsListPage';
import { InspectionDetailPage } from './features/inspections/InspectionDetailPage';
import { InspectionEditRoot, WizardRoot } from './features/inspections/wizard/WizardRoutes';
import { InspectionFormPage } from './features/inspections/forms/InspectionFormPage';
import { ReportViewPage } from './features/inspections/documents/ReportViewPage';
import { ChartsPage } from './features/inspections/charts/ChartsPage';
import { CustomFieldMovePage, CustomFieldTypePage, CustomFieldsPage } from './features/inspections/forms/CustomFieldPages';
import { TemplatesPage } from './features/forms/templates/TemplatesPage';
import { TemplateDetailPage } from './features/forms/templates/TemplateDetailPage';
import { TemplateImportPage } from './features/forms/templates/TemplateImportPage';
import { DraftEditorPage, DraftFieldMovePage, DraftFieldTypePage, DraftPreviewPage, VersionPage } from './features/forms/templates/DraftPages';
import { Step1NameSubjectType } from './features/inspections/wizard/Step1NameSubjectType';
import { Step2Team } from './features/inspections/wizard/Step2Team';
import { Step3Timeframe } from './features/inspections/wizard/Step3Timeframe';
import { Step4Summary } from './features/inspections/wizard/Step4Summary';
import { WizardConfirmation } from './features/inspections/wizard/WizardConfirmation';

export const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'inspekcie', element: <InspectionsListPage /> },
      {
        path: 'inspekcie/nova',
        element: <WizardRoot />,
        children: [
          { index: true, element: <Navigate to="nazov-a-typ" replace /> },
          { path: 'nazov-a-typ', element: <Step1NameSubjectType /> },
          { path: 'tim', element: <Step2Team /> },
          { path: 'termin', element: <Step3Timeframe /> },
          { path: 'suhrn', element: <Step4Summary /> },
          { path: 'hotovo', element: <WizardConfirmation /> },
        ],
      },
      { path: 'inspekcie/:id', element: <InspectionDetailPage /> },
      {
        path: 'inspekcie/:id/upravit',
        element: <InspectionEditRoot />,
        children: [
          { index: true, element: <Navigate to="suhrn" replace /> },
          { path: 'nazov-a-typ', element: <Step1NameSubjectType /> },
          { path: 'tim', element: <Step2Team /> },
          { path: 'termin', element: <Step3Timeframe /> },
          { path: 'suhrn', element: <Step4Summary /> },
        ],
      },
      { path: 'inspekcie/:id/sprava', element: <ReportViewPage /> },
      { path: 'inspekcie/:id/grafy', element: <ChartsPage /> },
      { path: 'inspekcie/:id/formulare/:type', element: <InspectionFormPage /> },
      { path: 'inspekcie/:id/formulare/:type/polia', element: <CustomFieldsPage /> },
      { path: 'inspekcie/:id/formulare/:type/polia/novy', element: <CustomFieldTypePage /> },
      { path: 'inspekcie/:id/formulare/:type/polia/novy/:fieldType', element: <CustomFieldsPage /> },
      { path: 'inspekcie/:id/formulare/:type/polia/:key', element: <CustomFieldsPage /> },
      { path: 'inspekcie/:id/formulare/:type/polia/:key/presunut', element: <CustomFieldMovePage /> },
      { path: 'sablony', element: <TemplatesPage /> },
      { path: 'sablony/:type', element: <TemplateDetailPage /> },
      { path: 'sablony/:type/import', element: <TemplateImportPage /> },
      { path: 'sablony/:type/koncept', element: <DraftEditorPage /> },
      { path: 'sablony/:type/koncept/nahlad', element: <DraftPreviewPage /> },
      { path: 'sablony/:type/koncept/pole/novy', element: <DraftFieldTypePage /> },
      { path: 'sablony/:type/koncept/pole/novy/:fieldType', element: <DraftEditorPage /> },
      { path: 'sablony/:type/koncept/pole/:key/presunut', element: <DraftFieldMovePage /> },
      { path: 'sablony/:type/koncept/pole/:key', element: <DraftEditorPage /> },
      { path: 'sablony/:type/verzie/:no', element: <VersionPage /> },
      { path: 'subjekty', element: <SubjectsListPage /> },
      { path: 'subjekty/novy', element: <SubjectFormPage /> },
      { path: 'subjekty/:id', element: <SubjectDetailPage /> },
      { path: 'subjekty/:id/upravit', element: <SubjectFormPage /> },
      { path: 'inspektori', element: <InspectorsListPage /> },
      { path: 'inspektori/novy', element: <InspectorFormPage /> },
      { path: 'inspektori/:id', element: <InspectorDetailPage /> },
      { path: 'inspektori/:id/upravit', element: <InspectorFormPage /> },
      { path: 'audit', element: <AuditLogPage /> },
      { path: 'audit/:id', element: <AuditEntryPage /> },
      { path: 'pristupnost', element: <AccessibilityStatementPage /> },
      { path: 'logout', element: <LogoutPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export function createRouter() {
  return createBrowserRouter(routes);
}
